export const kategoriler = {
    title: 'Kategoriler',
    titleEN: 'Categories',
    description: 'Yemek.com\'da farklı yemek kategorileri ve tarifler',
    descriptionEN: 'Different food categories and recipes on Yemek.com',
    tabs: [
        {
            id: 1,
            title: 'Kategoriler',
            sliderPerView: 2,
            width: '100%',
            slides: [
                {
                    id: 1,
                    image: 'https://srv-cdn.onedio.com/store/a8df0ff804ab306c0ff67b4af27b628048ca4a7f005c6d63f303e8bcd496dd3a.png',
                    url: 'https://yemek.com/?google_preview=s_d6N7wYh7YY7su3yAYw7ufszwaIAYCAgJCyjbS1lQE&iu=21814681&gdfp_req=1&lineItemId=6931186758&creativeId=138509474857',
                    category: 'Şok Lio'

                },
                {
                    id: 2,
                    image: 'https://srv-cdn.onedio.com/store/02a6777bf817a2cae829306796c986009ad5846b0be844d18e8f5c3b0ff76dc6.png',
                    url: 'https://yemek.com/?google_preview=lEWQiFywPPIY6cq3yAYw6ebszwaIAYCAgJCyjcTtAg&iu=21814681&gdfp_req=1&lineItemId=6935681006&creativeId=138536402114',
                    category: 'Hasata'
                }
            ]
        }
    ],
    egTabs: [
        {
            id: 1,
            title: 'Categories',
            sliderPerView: 2,
            width: '100%',
            slides: [
                {
                    id: 1,
                    image: 'https://srv-cdn.onedio.com/store/a8df0ff804ab306c0ff67b4af27b628048ca4a7f005c6d63f303e8bcd496dd3a.png',
                    url: 'https://yemek.com/?google_preview=s_d6N7wYh7YY7su3yAYw7ufszwaIAYCAgJCyjbS1lQE&iu=21814681&gdfp_req=1&lineItemId=6931186758&creativeId=138509474857',
                    category: 'Şok Lio'


                },
                {
                    id: 2,
                    image: 'https://srv-cdn.onedio.com/store/02a6777bf817a2cae829306796c986009ad5846b0be844d18e8f5c3b0ff76dc6.png',
                    url: 'https://yemek.com/?google_preview=lEWQiFywPPIY6cq3yAYw6ebszwaIAYCAgJCyjcTtAg&iu=21814681&gdfp_req=1&lineItemId=6935681006&creativeId=138536402114',
                    category: 'Hasata'


                }
            ]
        }
    ]
} 